import { Component, OnInit } from "@angular/core";
import { MenuService } from "./menu.service";

import { TranslateService } from "@ngstack/translate";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  providers: [MenuService]
})
export class MenuComponent implements OnInit {
  currentLang = "fa";
  menuItems: any;

  constructor(
    public menuService: MenuService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.getListForManager();
  }

  addMenuItem(): void {
    // this.menuService.add({
    //   state: "menu",
    //   name: "MENU",
    //   type: "sub",
    //   icon: "trending_flat",
    //   children: [
    //     { state: "menu", name: "MENU" },
    //     { state: "timeline", name: "MENU" }
    //   ]
    // });
  }

  getListForManager() {
    this.menuService.getItemsForManager().subscribe(res => {
      this.menuItems = res;
      localStorage.setItem("menu", JSON.stringify(res));
    });
  }

  checkRoot(item: any) {
    return item.ActionList.includes("root")
  }
}
